/**
 * "Who's this for?" picker for the inquiry dialogs.
 *
 * Three role buttons in a 3-column grid — each filled with the role color
 * when selected, outlined when idle. (Original design — do not redesign.)
 *
 * Props:
 *   - value:   "bookkeeper" | "owner" | "staff"
 *   - onChange: fn(next)
 *   - testid:  optional prefix for data-testid (default "directed-to")
 */

const ROLES = [
  { v: "bookkeeper", label: "Bookkeeper", color: "#10B981" },
  { v: "owner",      label: "Owner",      color: "#002FA7" },
  { v: "staff",      label: "Admin",      color: "#7C3AED" },
];

export default function DirectedToPicker({ value, onChange, testid = "directed-to" }) {
  return (
    <div className="grid grid-cols-3 gap-2" data-testid={`${testid}-picker`}>
      {ROLES.map((opt) => {
        const active = value === opt.v;
        return (
          <button
            key={opt.v}
            type="button"
            onClick={() => onChange?.(opt.v)}
            className="px-3 py-2 text-sm border-2 transition-colors"
            style={{
              color: active ? "#FFFFFF" : opt.color,
              backgroundColor: active ? opt.color : "#FFFFFF",
              borderColor: opt.color,
            }}
            data-testid={`${testid}-${opt.v}`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
